/**
 * Get rid of complex (even nested) object fields with a specific name
 * @params obj, keysToRemove
 * @returns A new object without fields with that name(s)
 */

export default function removeObjectKeys(obj: Record<string, unknown>, keyToRemove: string): Record<string, unknown> {
  const newObj: Record<string, unknown> = { ...obj }
  delete newObj[keyToRemove]

  Object.keys(newObj).forEach((key) => {
    if (typeof newObj[key] === 'object' && !Array.isArray(newObj[key])) {
      const cleanedObj = removeObjectKeys(newObj[key] as Record<string, unknown>, keyToRemove)

      if (Object.keys(cleanedObj).length > 0) {
        newObj[key] = cleanedObj
      }
    }

    if (Array.isArray(newObj[key])) {
      ;(newObj[key] as unknown[]).forEach((el, i) => {
        if (typeof el === 'object' && !Array.isArray(el)) {
          const cleanedObj = removeObjectKeys(el as Record<string, unknown>, keyToRemove)

          if (typeof newObj[key] !== 'object') {
            // TODO: handle also super nested arrays
            try {
              delete (newObj[key] as unknown[])[i]
              // eslint-disable-next-line no-empty
            } catch (err) {}
          }
          try {
            ;(newObj[key] as unknown[])[i] = cleanedObj ?? {}
            // eslint-disable-next-line no-empty
          } catch (err) {}
        }
      })
    }
  })
  return newObj
}
